/**
 * [getJSONFromPage]
 * @return {object} - JSON object from script
 * @param element
 * see addQuizJsonToPage
 */
const getJSONFromPage = (element = ".quiz-json") => {
  const dataScript =  (typeof document !== 'undefined') ? document.querySelectorAll(element)[0] : null
  if (!!dataScript) {
    const content = dataScript.innerHTML
    try {
      return JSON.parse(content)
    } catch (e) {
      return null
    }
  }
  return null
}

export default getJSONFromPage
